import { DateTime } from "luxon";

export function getTokenExpirationSeconds(token: string): number | undefined {
  const encodedPayload = token.split(".")[1];

  if (!encodedPayload) {
    return undefined;
  }

  try {
    const base64 = encodedPayload.replace(/-/g, "+").replace(/_/g, "/");
    const payload = JSON.parse(atob(base64));

    return typeof payload.exp === "number" && Number.isFinite(payload.exp) ? payload.exp : undefined;
  } catch {
    return undefined;
  }
}

export function isTokenWillExpireSoon(token: string, minutes: number) {
  const expiration = getTokenExpirationSeconds(token);

  if (expiration === undefined) {
    return true;
  }

  const nextExpirationDate = DateTime.now().plus({ minutes });

  return nextExpirationDate.toUnixInteger() >= expiration;
}
